export const Comment1 = () => {
  return (
    <svg width='23' height='19' viewBox='0 0 23 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16.0126 4.3501H6.3376C5.8876 4.3501 5.4751 4.7251 5.4751 5.2126C5.4751 5.7001 5.8501 6.0751 6.3376 6.0751H16.0501C16.5001 6.0751 16.9126 5.7001 16.9126 5.2126C16.9126 4.7251 16.5001 4.3501 16.0126 4.3501Z'
        fill='#637381'
      />
      <path
        d='M14.0626 8.92505H6.3376C5.8876 8.92505 5.4751 9.30005 5.4751 9.78755C5.4751 10.275 5.8501 10.65 6.3376 10.65H14.0626C14.5126 10.65 14.9251 10.275 14.9251 9.78755C14.9251 9.30005 14.5126 8.92505 14.0626 8.92505Z'
        fill='#637381'
      />
      <path
        d='M20.3625 0H2.3625C1.0875 0 0 1.05 0 2.3625V16.5C0 17.1 0.3375 17.6625 0.9 17.925C1.125 18.0375 1.35 18.075 1.575 18.075C1.95 18.075 2.2875 17.9625 2.5875 17.7L5.775 15.075H20.3625C21.6375 15.075 22.725 14.025 22.725 12.7125V2.3625C22.725 1.05 21.6375 0 20.3625 0ZM21.0375 12.7125C21.0375 13.0875 20.7375 13.3875 20.3625 13.3875H5.475C5.2875 13.3875 5.1 13.4625 4.95 13.575L1.725 16.2375V2.3625C1.725 1.9875 2.025 1.6875 2.4 1.6875H20.4C20.775 1.6875 21.075 1.9875 21.075 2.3625V12.7125H21.0375Z'
        fill='#637381'
      />
    </svg>
  );
};
